import $ from 'jquery';
import TwitterFetcher from 'twitter-fetcher';

export default class DynamicTwitter {
  constructor(section) {
    this.$el = $(section.el);
    this.initializedClass = 'twitter-initialized';

    this._validate();
  }

  _validate() {
    this.tweetContainer = $('[data-twitter-tweets]', this.$el);
    const username = $('[data-twitter-username]', this.$el).attr('data-twitter-username');
    const retweets = $('[data-show-retweets]', this.$el).length;
    const showImages = $('[data-show-images]', this.$el).length;
    const isInitialized = this.$el.hasClass(this.initializedClass);

    if (this.tweetContainer.length) {
      if (!isInitialized) {
        this._fetchTweets(username, retweets, showImages);
      }
    } else {
      this._toggleOnBoarding();
    }
  }

  _toggleOnBoarding() {
    this.$el.removeClass('module-hidden')
      .removeClass(this.initializedClass);
  }

  _fetchTweets(username, retweets, showImages) {
    const config = {
      profile: { screenName: username },
      maxTweets: 1,
      enableLinks: true,
      showUser: true,
      showTime: true,
      showRetweet: retweets,
      customCallback: tweets => this.renderTweets(tweets),
      showInteraction: false,
      useEmoji: true,
      showImages: showImages,
    };

    TwitterFetcher.fetch(config);
  }

  renderTweets(tweets) {
    if (tweets.length) {
      const $tweet = $(tweets[0]);
      const media = $($tweet[3]);

      this.tweetContainer.html($tweet[1]);
      this.$el.removeClass('module-hidden')
        .addClass(this.initializedClass);

      if (media.length) {
        this.tweetContainer.addClass('has-image').prepend(media);
      }
    } else {
      // twitterFetcher changes the view element to window, so we cannot use @$el here
      this.tweetContainer.html();
      this.$el.addClass('module-hidden')
        .removeClass(this.initializedClass);
    }
  }

  update($el) {
    // Resets the @$el for the current closure
    this.$el = $el;
    this._validate();
  }
}
